import Api from './Api'
import download from 'downloadjs'
// import store from '../store/store'

export default {
  async show(parameters) {
    const api = await Api()
    return api.post('tasks', parameters)
  },
  async getCubes(parameters) {
    const api = await Api()
    return api.post('cubes', parameters)
  },
  async getDims(parameters) {
    const api = await Api()
    return api.post('dims', parameters)
  },
  async getCubeDims(parameters) {
    const api = await Api()
    return api.post('cube/dims', parameters)
  },
  async getDimRootElements(parameters) {
    const api = await Api()
    return api.post('dim/elements', parameters)
  },
  async getDimAliases(parameters) {
    const api = await Api()
    return api.post('dim/aliases', parameters)
  },
  async save(parameters) {
    const api = await Api()
    return api.post('task/save', parameters)
  },
  async getDetails(parameters) {
    const api = await Api()
    const res = await api.post('task', parameters)
    const processDims = (dim) => {
      let selection = dim.selection
      let display = dim.selection
      if (dim.selectionType === 'Multi-Select') {
        selection = JSON.parse(selection)
        display = selection.map((el) => el.name).join(', ')
      }
      return { ...dim, selection, display }
    }
    res.data.targetTaskDims = res.data.targetTaskDims.map(processDims)
    res.data.sourceTaskDims = res.data.sourceTaskDims.map(processDims)
    res.data.targetCubeTaskDims = res.data.targetCubeTaskDims.map(processDims)
    res.data.sourceCubeTaskDims = res.data.sourceCubeTaskDims.map(processDims)
    return res
  },
  async delete(parameters) {
    const api = await Api()
    return api.post('task/delete', parameters)
  },
  async run(parameters) {
    const api = await Api()
    return api.post('task/run', parameters)
  },
  async getElementChildren(parameters) {
    const api = await Api()
    return api.post('element/children', parameters)
  },
  async searchElements(parameters) {
    const api = await Api()
    return api.post('dim/elements/search', parameters)
  },
  async getHistory(parameters) {
    const api = await Api()
    return api.post('task/history', parameters)
  },
  async getAllHistory(parameters) {
    const api = await Api()
    return api.post('tasks/all-history', parameters)
  },
  async filterCubes(parameters) {
    const api = await Api()
    return api.post('cubes/filter', parameters)
  },
  async runQuick(parameters) {
    const api = await Api()
    return api.post('task/quick-run', parameters)
  },
  async getHistoryDetails(parameters) {
    const api = await Api()
    return api.post('task/history/details', parameters)
  },
  async getFilteredHistoryDetails(
    taskHistoryIds,
    totalFilter,
    currentUserId,
    dateRange
  ) {
    const api = await Api()
    const response = await api.post(
      'taskHistory/download',
      {
        taskHistoryIds,
        totalFilter,
        currentUserId,
        dateRange,
      },
      { responseType: 'blob' }
    )
    download(response.data, 'report.pdf', 'application/pdf')
  },
  async getLog(parameters) {
    const api = await Api()
    return api.post('task/log', parameters)
  },
  async getErrorLog(parameters) {
    const api = await Api()
    return api.post('error-log', parameters)
  },
  async getHistoryResults() {
    const api = await Api()
    return api.post('task/completed-histories')
  },
  async createElement(parameters) {
    const api = await Api()
    return api.post('new-element', parameters)
  },
  async getHierarchies(parameters) {
    const api = await Api()
    return api.post('dim/hierarchies', parameters)
  },
  async getSubsets(parameters) {
    const api = await Api()
    return api.post('dim/subsets', parameters)
  },
  async getSubsetElements(parameters) {
    const api = await Api()
    return api.post('dim/subset/elements', parameters)
  },
  async getAttributes(parameters) {
    const api = await Api()
    return api.post('dim/attributes', parameters)
  },
  async getSelectionDrillDown(parameters) {
    const api = await Api()
    return api.post('dim/getSelectionDrillDown', parameters)
  },
}
